const getApiUrl = () => {
    const customApiUrl = localStorage.getItem('customApiUrl');
    return customApiUrl || "https://api-slotify.unternehmen.online/";
};

const SyncConstants = {
    "syncBaseURL" : getApiUrl(),
    "slotifyVersion" : "56"
}

export default SyncConstants;
